import { Achievements } from './Achievements';
// const animation = {
// 	hidden: {
// 		opacity: 0,
// 	},
// 	visible: {
// 		opacity: 1,
// 		transition: {
// 			duration: 0.25,
// 		},
// 	},
// };

export const OpeningMobile = () => {
	return (
		<div className='md:hidden'>
			<div className='relative flex h-[calc(100vh_-_64px)] w-screen'>
				<div className='flex h-full w-full flex-col justify-evenly rounded-bl-lg rounded-br-lg'>
					<img
						alt='Sawaed logo'
						src='/logo-white.webp'
						fetchPriority='high'
						width={440}
						height={283}
						className='mx-auto h-auto w-[60vw] pt-4'
					/>

					<div className='container flex items-center justify-center'>
						<div className='mx-auto rounded-md pt-2 font-bold text-white'>
							<h2 className='mb-2 block font-poppins text-3xl font-normal leading-none tracking-tighter'>
								<span> Build the </span>
								<div className='typewriter inline-flex items-end'>
									<span className='m-0 inline-block h-full border-l-[3px] border-solid border-primary-700 pb-1 pl-3 pr-4 pt-2 font-Sarah text-2xl font-semibold leading-none tracking-wide text-primary-800 [background:linear-gradient(_90deg,#fff_-5%,rgba(255,255,255,0)_100%_)]'>
										FUTURE
									</span>
								</div>
							</h2>
							<h2 className='block font-poppins text-3xl font-normal leading-none tracking-tighter'>
								Build with{' '}
								<div className='typewriter inline-flex items-end'>
									<span className='inline-block border-l-[3px] border-solid border-primary-700 pb-1 pl-3 pr-4 pt-2 font-Sarah text-2xl font-semibold leading-none tracking-wide text-primary-800 [background:linear-gradient(_90deg,#fff_-5%,rgba(255,255,255,0)_100%_)]'>
										TRUST
									</span>
								</div>
							</h2>
						</div>
					</div>

					<Achievements />
				</div>
			</div>
			<div
				id='more-sections'
				className='absolute bottom-0 left-0 right-0 z-0'
			/>
		</div>
	);
};
